import Discounts from './Discounts'
import ccDiscountsNew from './DiscountsNew'
export let DiscountsNew = ccDiscountsNew
export default Discounts



// WEBPACK FOOTER //
// ./components/pages/order/Discounts/index.js